import { action } from "typesafe-actions";
import { KycActionTypes } from "./kyc.model";

export const fetchKycRequest = (req) => action(KycActionTypes.FETCH_KYC_REQUEST, req);
export const fetchKycSuccess = (res) => action(KycActionTypes.FETCH_KYC_SUCCESS, res);
export const fetchKycFailure = (err) => action(KycActionTypes.FETCH_KYC_FAILURE, err);

export const fetchKycDetailRequest = (id) => action(KycActionTypes.FETCH_KYC_DETAIL_REQUEST, id);
export const fetchKycDetailSuccess = (res) => action(KycActionTypes.FETCH_KYC_DETAIL_SUCCESS, res);
export const fetchKycDetailFailure = (err) => action(KycActionTypes.FETCH_KYC_DETAIL_FAILURE, err);

/** Drops the open application so the next one is never rendered over the last one's data. */
export const clearKycDetail = () => action(KycActionTypes.CLEAR_KYC_DETAIL);

export const testConnectionRequest = (country) => action(KycActionTypes.TEST_CONNECTION_REQUEST, country);
export const testConnectionSuccess = (res) => action(KycActionTypes.TEST_CONNECTION_SUCCESS, res);
export const testConnectionFailure = (err) => action(KycActionTypes.TEST_CONNECTION_FAILURE, err);
